import AdminCrud from "@/pages/admin/components/AdminCrud";
import type { CrudField } from "@/pages/admin/components/AdminCrud";

const fields: CrudField[] = [
  { key: "title", label: "Titre", required: true },
  { key: "description", label: "Description", type: "textarea" },
  { key: "icon", label: "Icône", type: "icon" },
];

export default function AdminValeurs() {
  return (
    <AdminCrud
      title="Valeurs"
      description="Les valeurs fondamentales de l'association."
      addLabel="Ajouter une valeur"
      table="core_values"
      fields={fields}
      listTitleKey="title"
      listIconKey="icon"
    />
  );
}